// Browser notifications for the queue status page. They work while the page is
// open (including in a background tab). iPhones only allow them once the site
// is added to the home screen, so the page also alerts in-page.

const SW_URL = "/queue-sw.js";
const SW_SCOPE = "/queue/";

export const notificationsSupported = () =>
  typeof window !== "undefined" && "Notification" in window;

export const notificationPermission = () =>
  notificationsSupported() ? window.Notification.permission : "unsupported";

export const registerQueueServiceWorker = async () => {
  if (typeof navigator === "undefined" || !navigator.serviceWorker) return null;
  try {
    return await navigator.serviceWorker.register(SW_URL, { scope: SW_SCOPE });
  } catch (err) {
    console.error("queue service worker registration failed", err);
    return null;
  }
};

export const requestNotificationPermission = async () => {
  if (!notificationsSupported()) return "unsupported";
  try {
    return await window.Notification.requestPermission();
  } catch (err) {
    console.error("notification permission request failed", err);
    return window.Notification.permission;
  }
};

// Returns true when a system notification was shown.
export const showQueueNotification = async ({ title, body, icon, url }) => {
  if (notificationPermission() !== "granted") return false;
  const options = { body, icon, tag: "queue-status", renotify: true, data: { url } };
  try {
    const registration = navigator.serviceWorker
      ? await navigator.serviceWorker.getRegistration(SW_SCOPE)
      : null;
    if (registration) {
      await registration.showNotification(title, options);
    } else {
      new window.Notification(title, options);
    }
    return true;
  } catch (err) {
    console.error("showing queue notification failed", err);
    return false;
  }
};
